import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Typography from '@material-ui/core/Typography'

import { openingRuleItems, OPENING_RULE, gameResultsItems } from '../../../constants'
import ConfirmDialog from '../ConfirmDialog'
import { Word } from '../../../containers';
import { WID, getWord } from '../../../constants/Language';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  textFieldFullWidth: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '100%',
    maxWidth: 416,
  },
});


class GameInfoDialog extends React.Component {
  state = {
    title: '',
    openingRule: OPENING_RULE.NONE,
    blackPlayerName: '',
    whitePlayerName: '',
    gameEndNumber: '',
    gameResult: '',
    before: {},
    confirmDialog: {
      open: false,
    }
  }

  handleChangeText = (name) => (event) => {
    this.setState({ [name]: event.target.value })
  }
  
  handleEnter = () => {
    this.setState({ ...this.props.gameInfo, before: this.props.gameInfo })
  }

  handleOK = () => {
    const { moves } = this.props
    const { title, openingRule, blackPlayerName, whitePlayerName, gameEndNumber, gameResult, before } = this.state
    if (openingRule !== before.openingRule && moves.length > 1) {
      this.setState({ confirmDialog: { open: true }})
    }
    else {
      this.props.handleOK({ title, openingRule, blackPlayerName, whitePlayerName, gameEndNumber, gameResult })
    }
  }

  confirmDialog = {
    handleOK: () => {
      const { title, openingRule, blackPlayerName, whitePlayerName, gameEndNumber, gameResult } = this.state
      this.props.handleOK({ title, openingRule, blackPlayerName, whitePlayerName, gameEndNumber, gameResult })
      this.setState({ confirmDialog: { open: false }})
    },
    handleClose: () => {
      this.setState({ confirmDialog: { open: false }})
    }
  }

  getGameEndNumberItem = (moves, language) => {
    var gameEndNumberItem, move, label, value
    gameEndNumberItem = [{label: '', value: ''}];
    for (move of moves) {
      if( 1 <= move.number && 225 >= move.number ){
        if (move.color === 'black') {
          label = getWord(WID.GAME_INFO_DIALOG.BLACK, language, { number: move.number.toString(10) })
          value = 'black-' + move.number.toString(10);
        }
        else if (move.color === 'white'){
          label = getWord(WID.GAME_INFO_DIALOG.WHITE, language, { number: move.number.toString(10) })
          value = 'white-' + move.number.toString(10);
        }
        else {
          break;
        }
        gameEndNumberItem.push({label: label, value: value});
      }
    }
    return gameEndNumberItem
  }

  render() {
    var openingRuleItem
    const { fullScreen, classes, open, moves, handleClose, language } = this.props
    const { title, openingRule, blackPlayerName, whitePlayerName, gameEndNumber, gameResult, confirmDialog } = this.state
    const gameEndNumberItem = this.getGameEndNumberItem(moves, language)

    openingRuleItem = openingRuleItems.find(item => item.value === openingRule)
    const { player1wid, player2wid } = openingRuleItem !== undefined ?
      openingRuleItem : { player1wid: '', player2wid: '' }

    return (
      <React.Fragment>
        <Dialog fullScreen={fullScreen} open={open} onClose={handleClose} onEnter={this.handleEnter}>
          <DialogTitle><Word wid={WID.GAME_INFO_DIALOG.DIALOG_TITLE}/></DialogTitle>
          <DialogContent>
            <div>
              <TextField
                label={<Word wid={WID.GAME_INFO_DIALOG.OPENING_RULE_LABEL}/>}
                select
                className={classes.textField}
                onChange={this.handleChangeText('openingRule')}
                value={openingRule}
                margin="normal"
              >
                {openingRuleItems.map(item => 
                  <MenuItem key={item.value} value={item.value}>
                    <Word wid={item.wid}/>
                  </MenuItem>
                )}
              </TextField>
            </div>
            <div>
              <TextField
                id="title"
                label={<Word wid={WID.GAME_INFO_DIALOG.TITLE_LABEL}/>}
                className={classes.textFieldFullWidth}
                onChange={this.handleChangeText('title')}
                value={title}
                margin="normal"
              />
            </div>
            <div>
              <TextField
                label={`${getWord(WID.GAME_INFO_DIALOG.PLAYER_NAME_LABEL, language)} (${getWord(player1wid, language)})`}
                className={classes.textField}
                onChange={this.handleChangeText('blackPlayerName')}
                value={blackPlayerName}
                margin="normal"
              />
              <TextField
                label={`${getWord(WID.GAME_INFO_DIALOG.PLAYER_NAME_LABEL, language)} (${getWord(player2wid, language)})`}
                className={classes.textField}
                onChange={this.handleChangeText('whitePlayerName')}
                value={whitePlayerName}
                margin="normal"
              />
            </div>
            <div>
              <TextField
                label={<Word wid={WID.GAME_INFO_DIALOG.NUMBER_OF_MOVES_AT_THE_END_OF_THE_GAME_LABEL}/>}
                select
                className={classes.textField}
                onChange={this.handleChangeText('gameEndNumber')}
                value={gameEndNumber}
                margin="normal"
              >
                {gameEndNumberItem.map(item =>
                  <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                )}
              </TextField>
              <TextField
                label={<Word wid={WID.GAME_INFO_DIALOG.GAME_RESULT}/>}
                select
                className={classes.textField}
                onChange={this.handleChangeText('gameResult')}
                value={gameResult}
                margin="normal"
              >
                {gameResultsItems.map(item =>
                  <MenuItem key={item.value} value={item.value}>
                    <Word wid={item.wid}/>
                  </MenuItem>
                )}
              </TextField>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary" autoFocus>
                Cancel
            </Button>
            <Button onClick={this.handleOK} color="primary" autoFocus>
                OK
            </Button>
          </DialogActions>
        </Dialog>
        <ConfirmDialog
          open={confirmDialog.open}
          title={<Word wid={WID.GAME_INFO_DIALOG.NOTIFY_DIALOG.DIALOG_TITLE}/>}
          content={
            <Typography><Word wid={WID.GAME_INFO_DIALOG.NOTIFY_DIALOG.CONTENT}/></Typography>
          }
          onOK={this.confirmDialog.handleOK}
          onClose={this.confirmDialog.handleClose}
        />
      </React.Fragment>
    )
  }
}

export default withMobileDialog()(withStyles(styles)(GameInfoDialog))


// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/GameInfoDialog.js